<app-common-header></app-common-header>
<!-- <button class="src-component-launcher-WidgetLauncher-wrapper" (click)="help()">
  <span
    class="src-component-Icon-container Icon fa fa-question-circle"
    type="Icon"
  >
  </span>
  <span class="src-component-launcher-WidgetLauncher-label">Help</span>
</button> -->
<!-- <div>
  <app-help></app-help>
</div> -->
<main role="main" class="maincnt quest">
  <div class="getbannersect sectppad pb-2" [ngClass]="{ 'pt-0': !isMobileView }">
    <div class="col-sm-12 p-0">
      <a
        href="javascript:void(0)"
        class="backbtn webview lftalign"
        (click)="back()"
      ></a>
    </div>
    <div class="sectpad container">
      <div class="col-sm-12 p-0">
        <div class="col-12 text-center webview">
          <!-- <img
            src="assets/images/eva-icons.svg"
            class="signimg prescsimg"
            width="100"
          /> -->
        </div>
        <div
          class="col-sm-12 p-0 mt-1 preimgmrgn webview"
          *ngIf="!orderDetails"
        >
          <h1 class="text-center prescsmsg preectlnhgt prelnhgt">
            Let the signup begin! But first, <br />
            let's get some info on you.
          </h1>
        </div>
        <div
          class="col-sm-12 p-0 mt-1 preimgmrgn webview"
          *ngIf="orderDetails && !showService"
        >
          <h1 class="text-center prescsmsg preectlnhgt prelnhgt">
            When are you wanting to start service?
          </h1>
        </div>
        <div class="col-sm-12 p-0 mt-1 preimgmrgn webview" *ngIf="showService">
          <h1 id="headerText" class="text-center prescsmsg preectlnhgt prelnhgt" [innerHTML]="headerText">
            
          </h1>
        </div>
        <div *ngIf="!orderDetails" class="mobileview mt-3">
          <div class="d-flex h-100 row col-sm-12 m-0">
            <div
              class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
            >
              <img style="width: 100%" src="assets/images/signimg.jpg" />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div class="arrow_box">
                <h1 class="questionMob text-left">
                  Let the signup begin! But first, <br />
                  let's get some info on you.
                </h1>
                <!-- <h1 class="questionMob text-left">Let the savings begin! But first,
                  <br>let’s get some info on you.</h1> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 p-0 order">
          <ul class="nav nav-pills nav-border nav-fill w-100 mb-4 webview">
            <li class="col-sm-4 nav-item text-center">
              <button
                class="nav-link text-center d-inline-block btnborder fntfive"
                id="confirm_click"
                data-toggle="pill"
                [disabled]="confirmDisable"
              >
                1. CONFIRM ADDRESS
              </button>
            </li>
            <li class="col-sm-4 nav-item text-center" id="servicetabb">
              <button
                class="text-center btnborder d-inline-block fntfive"
                id="service_click"
                data-toggle="pill"
                [disabled]="serviceDisablee"
              >
                2. SERVICE TYPE
              </button>
            </li>
            <li class="col-sm-4 nav-item text-center">
              <button
                class="text-center btnborder d-inline-block fntfive"
                id="enrollment_click"
                data-toggle="pill"
                [disabled]="enrollmentDisable"
              >
                3. ENROLLMENT
              </button>
            </li>
          </ul>
          <div class="row col-sm-12 m-0 p-0">
            <!-- Tab panes -->
            <div class="col-sm-12 col-md-7 col-lg-7 mt-2">
              <div class="tab-content tab-drpdown">
                <div class="tab-pane container active p-0" id="confirm">
                  <h4 class="plan-heading pb-3">
                    Please confirm your Service Address
                  </h4>
                  <div class="col-md-12 mb-2 p-0">
                    <agm-map
                      [latitude]="lat"
                      [longitude]="lng"
                      [zoomControl]="false"
                      [disableDoubleClickZoom]="true"
                      [zoom]="18"
                      [scrollwheel]="false"
                      [streetViewControl]="false"
                    >
                      <agm-marker
                        [latitude]="lat"
                        [longitude]="lng"
                        [iconUrl]="markerIconUrl()"
                      ></agm-marker>
                    </agm-map>
                  </div>
                  <div class="row col-sm-12 m-0 p-0">
                    <div class="col-sm-9 col-9 p-0">
                      <div class="row col-sm-12 p-0 m-0" id="autocompletediv">
                        <input
                          ngx-google-places-autocomplete
                          [options]="options"
                          #placesRef="ngx-places"
                          (ngModelChange)="setFlag($event)"
                          (onAddressChange)="handleAddressChange($event)"
                          type="text"
                          id="autocomplete"
                          class="form-control"
                          placeholder="Street address, City, State"
                          [(ngModel)]="ChangedformatedAddress"
                          [disabled]="disabled"
                        />
                      </div>
                    </div>
                    <div class="col-sm-3 col-3 pr-0">
                      <input
                        name="Apartment"
                        class="form-control"
                        type="text"
                        id="aptdiv"
                        placeholder="Unit"
                        [(ngModel)]="apartment"
                        [disabled]="disabled"
                      />
                    </div>
                  </div>
                  <div class="m-0 row col-sm-12 p-0 justify-content-end mt-2">
                    <div class="mt-2 change-btn">
                      <a
                        class="btnimpl navboxclr intial-btn ml-3 font16 text-right mr-1 handsymbol"
                        (click)="change()"
                        >Change</a
                      >
                    </div>
                    <div *ngIf="!confirmFlag" class="mt-2">
                      <a
                        class="btnimpl navboxclr confirm-intial-btn ml-3 font16 text-right mr-1 handsymbol"
                        (click)="confirm()"
                        >Confirm</a
                      >
                    </div>
                    <div *ngIf="confirmFlag" class="mt-2 change-btn">
                      <a
                        class="btnimpl navboxclr confirm-btn ml-3 font16 text-right mr-1 handsymbol"
                        (click)="confirm()"
                        >Confirm</a
                      >
                    </div>
                  </div>
                  <div class="row mt-2 addressFields" style="display: none;">
                    <div class="col-sm-9 col-9">
                      <label for="home_address font-weight-semibold-calibre"
                        >Home Address</label
                      >
                      <input
                        type="text"
                        id="Home Address"
                        [(ngModel)]="home_address"
                        class="form-control"
                        readonly
                      />
                    </div>
                    <div class="col-sm-3 col-3 pl-0">
                      <label for="type font-weight-semibold-calibre"
                        >Type</label
                      >
                      <input
                        name="type"
                        class="form-control"
                        type="text"
                        id="type"
                        placeholder=""
                        value="Residential"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row mt-2 mobileview addressFields" style="display: none;">
                    <div class="col-sm-9 addressFields" style="display: none;" id="order">
                      <label for="esiid font-weight-semibold-calibre"
                        >ESI ID</label
                      >
                      <input
                        *ngIf="singleEsiid"
                        name="type"
                        class="form-control"
                        type="text"
                        id="esiid"
                        [(ngModel)]="selectedEsiid"
                        placeholder="ESI ID"
                        readonly
                      />
                      <ng-select
                        *ngIf="!singleEsiid"
                        name="esiid"
                        [items]="esiidResponses"
                        placeholder="Select"
                        [searchable]="true"
                        [clearable]="false"
                        (change)="checkEsiidExists()"
                        [(ngModel)]="selectedEsiid"
                        style="width: 370px"
                      ></ng-select>
                    </div>
                  </div>
                  <div class="row mt-2 webview addressFields" style="display: none;">
                    <div class="col-sm-9" id="order">
                      <label for="esiid font-weight-semibold-calibre"
                        >ESI ID</label
                      >
                      <input
                        *ngIf="singleEsiid"
                        name="type"
                        class="form-control"
                        type="text"
                        id="esiid"
                        [(ngModel)]="selectedEsiid"
                        placeholder="ESI ID"
                        readonly
                      />
                      <ng-select
                        *ngIf="!singleEsiid"
                        name="esiid"
                        [items]="esiidResponses"
                        placeholder="Select"
                        [searchable]="true"
                        [clearable]="false"
                        (change)="checkEsiidExists()"
                        [(ngModel)]="selectedEsiid"
                        style="width: 100%"
                      ></ng-select>
                    </div>
                  </div>
                  <div class="row mt-2 webview addressFields" style="display: none;" *ngIf="enableESIDInput">
                    <div class="col-sm-9 col-9">
                      <label for="home_address font-weight-semibold-calibre"
                        ><a
                          href="https://utilitychoice.com/tools/esiid_lookup"
                          style="
                            color: #05f !important;
                            font-family: 'Calibre-SemiBold';
                          "
                          target="_blank"
                          >Click here </a
                        ><span
                          style="
                            color: #ed1976 !important;
                            font-family: 'Calibre-SemiBold';
                          "
                          >to search ESI ID then enter below</span
                        ></label
                      >
                      <input
                        type="text"
                        id="esiid1"
                        [(ngModel)]="lookUpEsiID"
                        class="form-control"
                        (ngModelChange)="getESIIDinputValue($event)"
                      />
                    </div>
                  </div>

                  <div class="row mt-2 mobileview addressFields" style="display: none;" *ngIf="enableESIDInput">
                    <div class="col-sm-12 col-12">
                      <label for="home_address font-weight-semibold-calibre"
                        ><a
                          href="https://utilitychoice.com/tools/esiid_lookup"
                          style="
                            color: #05f !important;
                            font-family: 'Calibre-SemiBold';
                          "
                          target="_blank"
                          >Click here
                        </a>
                        <span
                          style="
                            color: #ed1976 !important;
                            font-family: 'Calibre-SemiBold';
                          "
                          >to search ESI ID then enter below</span
                        ></label
                      >
                      <input
                        type="text"
                        id="esiid1"
                        [(ngModel)]="lookUpEsiID"
                        class="form-control"
                        (ngModelChange)="getESIIDinputValue($event)"
                      />
                    </div>
                  </div>

                  <div class="row mt-2 addressFields" style="display: none;">
                    <div class="col-sm-12 pl-0">
                      <div
                        class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                        style="margin-bottom: 0px !important"
                      >
                        <input
                          type="checkbox"
                          id="accept"
                          class="custom-control-input"
                          [(ngModel)]="billingAddress"
                          (click)="getAccept($event)"
                        />
                        <label
                          style="cursor: pointer !important; line-height: 100%"
                          class="custom-control-label mt-1"
                          for="accept"
                          >My billing address is the same as my service address
                          above</label
                        >
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!billingAddress" class="row addressFields" style="display: none;">
                    <div class="col-sm-12">
                      <label class="font-weight-semibold-calibre"
                        >Billing Address</label
                      >
                    </div>
                    <br />
                    <div class="col-sm-9 col-12 mb-2">
                      <input
                        type="text"
                        id="street_address"
                        [(ngModel)]="street_address"
                        class="form-control"
                        (ngModelChange)="validate()"
                        placeholder="Street Address"
                      />
                    </div>
                    <div class="col-sm-9 col-12 mb-2">
                      <input
                        type="text"
                        id="apt"
                        [(ngModel)]="apt"
                        class="form-control"
                        (ngModelChange)="validate()"
                        placeholder="Unit"
                      />
                    </div>
                    <div class="row col-sm-9 col-12 mb-2 pr-0">
                      <div class="col-sm-4 col-4 pr-0">
                        <input
                          type="text"
                          [(ngModel)]="city"
                          (ngModelChange)="validate()"
                          class="form-control"
                          placeholder="City"
                        />
                      </div>
                      <div class="col-sm-3 col-4 pr-0">
                        <ng-select
                          [items]="statesArr"
                          placeholder="Select"
                          [searchable]="false"
                          [clearable]="false"
                          name="selectedstate"
                          [(ngModel)]="state"
                          (change)="getState(state)"
                          #selectedstate="ngModel"
                        >
                        </ng-select>
                      </div>
                      <div class="col-sm-5 col-4 pr-0">
                        <input
                          type="tel"
                          numbersOnly
                          [(ngModel)]="zipcode"
                          (ngModelChange)="validate()"
                          class="form-control"
                          placeholder="Zip Code"
                          maxlength="5"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row pl-2 webview addressFields" style="display: none;">
                    <button
                      style="width: 150px !important"
                      class="btn mr-2 ml-2 disabledButton sectbtn mt-2 font18 text-uppercase handsymbol"
                      [disabled]="disableButton"
                      [ngClass]="{ sectbtn: ngClass }"
                      (click)="next('service',1)"
                    >
                      Next
                    </button>
                  </div>
                  <div class="mobileview text-center mt-3 mb-4 addressFields" style="display: none;">
                    <div class="col-12 px-0 addressFields" style="display: none;">
                      <a
                        id="confirm456"
                        [ngClass]="{
                          isDisabled: disableButton,
                          sectbtn: ngClass
                        }"
                        class="btn next disabledButton col-sm-4 mt-2 font18 text-uppercase text-center pt-2"
                        style="width: 150px !important; height: 50px !important"
                        [class.disabled]="disableButton"
                        (click)="next('confirm')"
                        >Next</a
                      >
                    </div>
                  </div>
                  <br />
                  <!--To load the component in mobile view-->
                  <div
                    id="serviceTypeMbl"
                    class="mobileview addressFields" style="display: none;"
                    *ngIf="isMobileView && showServiceComp"
                  >
                    <app-service-type *ngIf="ServiceCompWeb"
                      [esiid_value]="
                        selectedEsiid ? selectedEsiid : lookUpEsiID
                      "
                    ></app-service-type>
                  </div>
                </div>
                <div
                  class="tab-pane container fade p-0 webview"
                  id="service"
                  *ngIf="!isMobileView"
                >
                  <app-service-type *ngIf="ServiceCompWeb"
                    (sendDetails)="getDetails($event)"
                  ></app-service-type>
                </div>
                <div
                  class="tab-pane container fade p-0 webview"
                  id="enrollment"
                  *ngIf="!isMobileView"
                >
                  <app-enrollment
                    [esiid_value]="selectedEsiid ? selectedEsiid : lookUpEsiID"
                    (invoiceBack)="getInvoice($event)"
                  ></app-enrollment>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-5 col-lg-5 webview">
              <div *ngIf="orderDetails">
                <h4 class="plan-heading mt-2 pb-2">Order Details</h4>
                <div class="card p-1 mb-3">
                  <div class="table-responsive-sm">
                    <table class="table table-sm">
                      <tbody>
                        <tr class="bodrbtmm lnehgt" *ngIf="showService">
                          <th style="line-height: 1.5" scope="row">
                            Switch Type
                          </th>
                          <td class="pt-2" style="width: 30%">
                            {{ switchType }}
                          </td>
                          <td class="handsymbol">
                            <a
                              class="btnn"
                              data-toggle="pill"
                              (click)="next('service')"
                              >Edit</a
                            >
                          </td>
                        </tr>
                        <tr class="bodrbtmmDate lnehgt" *ngIf="showService">
                          <th style="line-height: 1.5" scope="row">
                            Start Date
                          </th>
                          <td class="pt-2">{{ startDate }}</td>
                          <!-- <td><a class="btnn" data-toggle="pill" (click)="next('service');">Edit</a></td> -->
                        </tr>
                        <tr>
                          <th colspan="2" scope="row">Service Address Info:</th>
                          <td class="handsymbol" align="right">
                            <a
                              class="btnn"
                              data-toggle="pill"
                              (click)="editnavigt('confirm')"
                              >Edit</a
                            >
                          </td>
                        </tr>

                        <tr class="lnehgt">
                          <td class="font-weight-normal-calibre">
                            {{ newFormattedAddress }}
                          </td>
                        </tr>
                        <tr
                          class="lnehgt"
                          *ngIf="
                            selectedEsiid ===
                            'ESI ID # Locator  Currently Unavailable'
                          "
                        >
                          <td class="font-weight-normal-calibre">
                            ESI ID: {{ esiid1 }}
                          </td>
                        </tr>
                        <tr
                          class="lnehgt"
                          *ngIf="
                            selectedEsiid !=
                            'ESI ID # Locator  Currently Unavailable'
                          "
                        >
                          <td class="font-weight-normal-calibre">
                            ESI ID: {{ esiid_value }}
                          </td>
                        </tr>
                        <!-- <p>{{home_address}}</p> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="servicemain">
                <div class="col-sm-12 col-md-12 col-lg-12 p-0">
                  <h3 class="plan-heading mt-2 mb-4">Your Plan Summary</h3>
                  <div class="plansummary">
                    <div class="d-flex">
                      <div class="col">
                        <div class="minhgt50p rateamt">
                          <div class="w-100 mt-2">
                            <img
                              style="max-height: 60px"
                              src="{{ selectedProduct.energy_provider_image }}"
                              alt="{{ selectedProductLogo() }}"
                              title="{{ selectedProductLogo() }}"
                            />
                            <p
                              class="m-1 font15 font-weight-normal-calibre"
                              id="puctid"
                            >
                              PUCT #{{ selectedProduct.puct }}
                            </p>
                          </div>
                        </div>
                        <div class="minhgt50p">
                          <div class="w-100 mt-1">
                            <span
                              class="fwgtsix"
                              style="line-height: 10px; display: block"
                            >
                              {{ selectedProduct.product_key }}
                            </span>
                            <span
                              class="font-weight-normal-calibre wrdbrk headingText"
                              style="display: block"
                            >
                              {{ selectedProduct.terms }} Months - Fixed
                            </span>
                            <span
                              class="fwgtsix"
                              *ngIf="selectedProduct.Renewable  && selectedProduct.energy_provider !== 'Texpo Energy'"
                              style="line-height: 10px; display: block"
                            >
                              <a
                                class="pikclr"
                                style="padding-bottom: 8px"
                                target="_blank"
                                >{{ selectedProduct.Renewable }}% Renewable</a
                              >
                            </span>
                          </div>
                          <div
                            style="clear: both; text-decoration: underline"
                            (click)="openDialog(selectedProduct)"
                            class="handsymbol"
                          >
                            {{ showAll === true ? "Hide Details" : "Show Details" }}
                          </div>
                        </div>
                      </div>
                      <div class="col text-center">
                        <div class="minhgt50p rateamt">
                          <div class="w-100">
                            <h1 class="clrpink fwgtsix pikclr mb-0 avgvalue">
                              {{ averagePrice.toFixed(1) }}¢
                            </h1>
                            <p style="line-height: 13px">Avg. Price per kWh*</p>
                          </div>
                        </div>
                        <div class="minhgt50p rateamt">
                          <div class="w-100">
                            <h1 class="fwgtsix rate avgvalue mb-0">
                              ${{ avgbill }}
                            </h1>
                            <!-- <h1 class="fwgtsix rate avgvalue">${{avgbill}}</h1> -->
                            <p style="line-height: 13px !important">
                              Avg. Monthly Bill Estimate*
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="showAll === true">
                      <hr class="mt-2 mb-1" />
                      <div class="plan row no-gutters px-2">
                        <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                          <p
                            class="fwgtsix"
                            style="font-size: 13px; font-weight: bolder"
                          >
                            Description
                          </p>
                          <p
                            class="font-weight-normal-calibre text-left"
                            style="font-size: 13px"
                            [innerHTML]="singleObj.description"
                          ></p>
                        </div>
                        <div class="d-flex mt-1">
                          <div class="col-2 d-flex flex-row pl-0 text-left">
                            <div class="float-left">
                              <img src="assets/images/pdf.svg" width="18" />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                href="{{ singleObj.productEFL }}"
                                target="_blank"
                                style="color: black !important"
                                >EFL</a
                              >
                            </div>
                          </div>

                          <div class="col-2 d-flex flex-row flexauto text-left">
                            <div class="float-left">
                              <img src="assets/images/pdf.svg" width="18" />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                href="{{ singleObj.productTOS }}"
                                target="_blank"
                                style="color: black !important"
                                >TOS</a
                              >
                            </div>
                          </div>
                          <div
                            class="col-4 d-flex flex-row flexauto pr-0 text-left"
                          >
                            <div class="float-left">
                              <img src="assets/images/pdf.svg" width="18" />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                href="{{ singleObj.productYRAC }}"
                                target="_blank"
                                style="color: black !important"
                                >YRAC</a
                              >
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                          <p
                            class="fwgtsix text-left"
                            style="font-size: 13px; font-weight: bolder"
                          >
                            Pricing Details
                          </p>
                          <div class="rounded">
                            <div>
                              <table class="table" style="margin-bottom: 0px">
                                <thead>
                                  <tr style="background: #e2e2e2">
                                    <th
                                      scope="col"
                                      class="font12 bold text-center"
                                      style="
                                        padding: 0.05rem !important;
                                        vertical-align: top;
                                        border-top: 1px solid #dee2e6;
                                      "
                                    >
                                      Monthly Usage
                                    </th>
                                    <th
                                      scope="col"
                                      class="font12 bold text-center"
                                      style="
                                        padding: 0.05rem !important;
                                        vertical-align: top;
                                        border-top: 1px solid #dee2e6;
                                      "
                                    >
                                      Average Price Per kWh
                                    </th>
                                    <th
                                      scope="col"
                                      class="font12 bold text-center"
                                      style="
                                        padding: 0.05rem !important;
                                        vertical-align: top;
                                        border-top: 1px solid #dee2e6;
                                      "
                                    >
                                      Monthly Estimate
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  style="
                                    font-size: 12px;
                                    font-family: Calibre;
                                    text-align: center;
                                    line-height: 10px;
                                  "
                                >
                                  <tr>
                                    <td>500 kWh</td>
                                    <td>{{ avgCharge500 }}¢</td>
                                    <td>${{ monthlyEstimates[0] }}</td>
                                  </tr>
                                  <tr>
                                    <td>1000 kWh</td>
                                    <td>{{ avgCharge1000 }}¢</td>
                                    <td>${{ monthlyEstimates[1] }}</td>
                                  </tr>
                                  <tr>
                                    <td>2000 kWh</td>
                                    <td>{{ avgCharge2000 }}¢</td>
                                    <td>${{ monthlyEstimates[2] }}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="background: deeppink; color: white"
                                    >
                                      {{ averageMonthlyUsage }} kWh
                                    </td>
                                    <td style="color: deeppink">
                                      {{ avgPricePerKWH }}¢
                                    </td>
                                    <td style="color: deeppink">
                                      ${{ avgMonthlyBill }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        font-size: 13px !important;
                                        padding: 0.05rem !important;
                                      "
                                    >
                                      Your Avg*
                                    </td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div>
                              <p style="font-size: 14px; font-weight: 800">
                                Here is how the plan charges above are
                                calculated:
                              </p>
                            </div>
                            <div
                              style="
                                font-size: 13px;
                                font-family: Calibre;
                                line-height: 11px;
                              "
                            >
                              <p 
                              *ngIf="
                              selectedProduct.energy_provider != 'Pulse Power' &&  selectedProduct.energy_provider != 'New Power Texas'  && selectedProduct.energy_provider !== 'Shell Energy'
                              "
                              > 
                                <span style="font-weight: bold"
                                  >Energy Charge</span
                                >: ${{ recommendedEnergyCharge }}
                                per kWh
                              </p>
                              <p 
                              *ngIf="
                              (selectedProduct.energy_provider == 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas'  || selectedProduct.energy_provider == 'Shell Energy' ) && selectedProduct.ProductType != 'TimeOfUse'
                              "
                              > 
                                <span style="font-weight: bold"
                                  >Energy Charge</span
                                >: ${{ recommendedEnergyCharge }}
                                per kWh
                              </p>
                              <div *ngIf=" (selectedProduct.energy_provider == 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' )  && selectedProduct.ProductType == 'TimeOfUse'">

                                <p >
                                  <span style="font-weight: bold"
                                  >Daytime Energy Charge</span>: {{ recommendedEnergyCharge }}
                                </p>
                                <p >
                                  <span style="font-weight: bold"
                                  >Daytime Energy Factor</span>: 60% 
                                </p>
                                <p>
                                  <span style="font-weight: bold"
                                  >Nighttime Energy Charge</span>: FREE
                                </p>
                                <p >
                                  <span style="font-weight: bold"
                                  >Nighttime Energy Factor</span>: 40% 
                                </p>
                              </div>

                              <p>
                                <span style="font-weight: bold"
                                  >Base Charge</span
                                >: ${{ recommendedBaseFee  }} per billing cycle
                                <!-- {{ recommendedBaseUsageLimit }} -->
                              </p>
                              <p
                              *ngIf="
                                (selectedProduct.usage1 != null ||
                                selectedProduct.usage2 != null) &&
                                (selectedProduct.energy_provider === 'Gexa Energy' ||
                                selectedProduct.energy_provider ===
                                    'Frontier Utilities')
                              "
                              class="WordSpace"
                            >
                            <span style="font-weight: bold">Usage Credit</span>:  {{selectedProduct.usage1Charge}} per billing cycle for usage >={{selectedProduct.usage1}} kWh
                            </p>

                              <p
                              class="WordSpace"
                              *ngIf="
                                (
                                  selectedProduct.energy_provider === 'Chariot Energy') && selectedProduct.billCredit !== '0' &&  selectedProduct.billCreditTrigger !== '0'
                              "
                            >
                            <span style="font-weight: bold">
                              Usage Credit</span
                            >:
                            {{ removeminus(selectedProduct.billCredit) }} per billing cycle of atleast {{ selectedProduct.billCreditTrigger }} kWh
                            </p>

                              <p
                        
                            
                              *ngIf="
                                (
                                selectedProduct.energy_provider === 'New Power Texas') && selectedProduct.billCredit != undefined && selectedProduct.minEnergyUsage !== 0 &&  selectedProduct.billCredit !== 0
                              "
                            >
                              <span style="font-weight: bold">Usage Credit</span>:
      
                              {{ removeminus(selectedProduct.billCredit) }} per billing cycle of atleast {{ selectedProduct.minEnergyUsage }} kWh
                            </p>
                              <p *ngIf="selectedProduct.energy_provider === '4Change Energy'">
                                <span style="font-weight: bold">
                                  Bill Credit</span
                                >: {{ removeminus(selectedProduct.billCredit) }} per billing cycle of atleast {{ selectedProduct.usageTrigger }} kWh
                              </p>
                              <p *ngIf="selectedProduct.energy_provider === 'Texpo Energy'"
                            >
                            <span style="font-weight: bold">Minimum Usage Fee</span>
                              ${{ selectedProduct.minEnergyCharge }} (for usage less than {{ selectedProduct.minEnergyUsage }} kWh)
          
                            </p>

                              <p class="WordSpace"
                                 *ngIf="selectedProduct.energy_provider === 'Shell Energy'  && selectedProduct.minEnergyCharge != 0 ">
                                  <span style="font-weight: bold">Minimum Usage Fee</span>
                                  ${{ selectedProduct.minEnergyCharge }} (all usage below {{ selectedProduct.minEnergyUsage }} kWh)

                              </p>
                              <p
                                class="WordSpace"
                                *ngIf="selectedProduct.energy_provider === 'Shell Energy'  && selectedProduct.ProductType.indexOf('Buyback') > -1 "
                              >
                                  <span style="font-weight: bold">Solar Buyback Rate</span>: Real-Time Market Rate

</p>


                            <div
                            *ngIf="
                              selectedProduct.energy_provider != 'Pulse Power'  &&  selectedProduct.energy_provider != 'New Power Texas'
                              
                              "
                            >

                            
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: ${{ recommendedTduCharge }} per billing cycle
                              </p>
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: ${{ recommendedTduDeliveryCharge }}
                                per kWh
                              </p>
                            </div>
                            <div
                            *ngIf="
                              (selectedProduct.energy_provider == 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' ) && selectedProduct.ProductType == 'TimeOfUse'
                              
                              "
                            >

                            
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: ${{ recommendedTduCharge }} per billing cycle
                              </p>
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: ${{ recommendedTduDeliveryCharge }}
                                per kWh
                              </p>
                            </div>
                            <div
                            *ngIf="
                              (selectedProduct.energy_provider == 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' ) && selectedProduct.ProductType != 'TimeOfUse'
                              
                              "
                            >

                            
                              <!-- <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: Bundled / Included per billing cycle
                              </p>
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: Bundled / Included
                                per kWh
                              </p> -->

                                  
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: ${{ recommendedTduCharge }} per billing cycle
                              </p>
                              <p>
                                <span style="font-weight: bold"
                                  >TDU Delivery Charge</span
                                >: ${{ recommendedTduDeliveryCharge }}
                                per kWh
                              </p>
                            </div>
                              <p
                              *ngIf="
                              (selectedProduct.energy_provider === 'Chariot Energy' ||
                              selectedProduct.energy_provider === 'APGE Energy')
                              "
                              >
                                <span style="font-weight: bold"
                                  >{{ selectedProduct.energy_provider === 'Chariot Energy' ? "Ercot Securitization Charge" : "Securitization Charge" }}</span
                                >: ${{selectedProduct.SecuritizationCharge}} per kWh
                               
                              </p>

                            </div>
                            <div
                            *ngIf="
                            selectedProduct.energy_provider != 'Pulse Power'  &&  selectedProduct.energy_provider != 'New Power Texas'

                            "
                              style="
                                font-size: 10px;
                                font-family: Calibre;
                                line-height: 11px;
                                padding-top: 8px;
                              "
                            >
                              *Avg. Price per kWh = ({{ productTitle }} Energy Charges {{ selectedProduct.energy_provider === 'APGE Energy' ? "+ Base Charge " :"" }}+
                               TDU Charges {{selectedProduct.energy_provider === 'Chariot Energy' || selectedProduct.energy_provider === 'APGE Energy' ? selectedProduct.SecuritizationChargeLabel : ""}}) / Total Monthly Usage
                            </div>
                            <div
                            *ngIf="
                            (selectedProduct.energy_provider == 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' ) && selectedProduct.ProductType != 'TimeOfUse'
                            "
                              style="
                                font-size: 10px;
                                font-family: Calibre;
                                line-height: 11px;
                                padding-top: 8px;
                              "
                            >
                            *Avg Price per kWh = (Energy Charge x Total Monthly Usage) + Base Charge
                            </div>
                            <div
                            *ngIf="
                            (selectedProduct.energy_provider == 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' ) && selectedProduct.ProductType == 'TimeOfUse'
                            "
                              style="
                                font-size: 10px;
                                font-family: Calibre;
                                line-height: 11px;
                                padding-top: 8px;
                              "
                            >
                            *Price per kWh = [TDU Delivery Charges per Month + (Monthly billed kWh Usage x (Energy Rate + TDU Delivery Charges per kWh)) - (Energy Rate x applicable Free Charging kWh Usage)]/Monthly Billed kWh Usage.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="plan row no-gutters px-2"
                        style="border-top: 0px; margin-top: 8px"
                      >
                        <div
                          class="fwgtsix handsymbol"
                          style="
                            font-size: 13px;
                            font-weight: bolder;
                            text-decoration: underline;
                          "
                          (click)="showHighcharts()"
                        >
                          {{ toggleHighcharts == true ? "Hide More Details" : "Show More Details" }}
                        </div>
                      </div>
                      <div
                        class="col-12 p-0"
                        style="margin-top: 20px"
                        *ngIf="toggleHighcharts"
                      >
                        <highcharts-chart
                          [Highcharts]="Highcharts"
                          [options]="highChartsOptions"
                          [(update)]="updateValue"
                          [runOutsideAngular]="true"
                          style="width: 100%; height: 350px; display: block"
                        ></highcharts-chart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- To Show the Esiid validation modal-->
<div
  class="modal fade"
  data-backdrop="static"
  data-keyboard="false"
  id="esiidCheck"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content zind1 boxRadius">
      <div class="modal-body">
        <button
          type="button"
          class="close mdlClose outline"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeResetModal()"
        >
          <div class="float-right mr-1 mt-0">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
        <div class="col-sm-12 mt-4 mb-3 p-0">
          <span class="lnhgt15 plan-heading borderBtm">Uh-oh!</span>

          <div class="borderTp">
            <div class="pt-3">
              <div>
                <font class="text-center esiidModal">{{
                  formatedAddress
                }}</font>
                <div class="esiidModal">
                  This address is proudly being served by Honest Gorilla
                  already. Please check to make sure you have the right address
                  and try again.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="utilities.length > 1">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        Multiple Utilities in {{ zip_code }}
      </h4>
      <p class="utility-sub-title font20 text-center">
        Please select your utility from the list below:
      </p>
      <div class="col-sm-12 mb-2" *ngFor="let utility of utilities">
        <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
          <div class="modal-cards w-100">
            <div
              class="card card-list pt-2 text-center"
              id="{{ utility.Utility }}"
              (click)="selectUtility(utility.Utility)"
            >
              <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-12">
                <img
                  src="{{ utility.src }}"
                  height="50"
                  class="mx-auto d-block"
                />
              </div>
              <label
                class="utility-sub-title font16"
                for="{{ utility.Utility }}"
                >{{ utility.Utility }}</label
              >
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="col-12 text-center">
        <p class="utility-sub-title font15" *ngIf="showMsg">{{ msg }}</p>
        <button
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
          (click)="goRecommendations()"
        >
          Next
        </button>
      </div>
    </div>
    <div *ngIf="utilities.length == 1">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        NEW UTILITY DETECTED
      </h4>
      <p class="utility-sub-title font20">
        The address you just entered is located in a different utility service
        territory. Your new address is served by:
      </p>
      <div class="col-sm-12 mb-2" *ngFor="let utility of utilities">
        <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
          <div class="modal-cards w-100">
            <div
              class="card card-list pt-2 text-center"
              id="{{ utility.Utility }}"
            >
              <div class="d-flex m-auto col-sm-12 col-md-12 col-xl-6">
                <img src="{{ utility.src }}" height="50" />
              </div>
              <label
                class="utility-sub-title font16"
                for="{{ utility.Utility }}"
                >{{ utility.Utility }}</label
              >
            </div>
          </div>
        </div>
      </div>
      <br />
      <p class="utility-sub-title font15 text-center" *ngIf="showMsg">
        {{ msg }}
      </p>
      <div class="col-12 text-center">
        <button
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
          (click)="goRecommendations()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noservice>
  <div class="modal-header py-0 px-0 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-2 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <h4
      class="utility-modal-title font20 text-center text-uppercase mb-4"
      *ngIf="zip_code"
    >
      SERVICE IS UNAVAILABLE FOR
    </h4>
    <h4
      class="utility-modal-title font20 text-center text-uppercase mb-4"
      style="line-height: 2px"
    >
      {{ houseAddress1 }}
    </h4>
    <h4
      class="utility-modal-title font20 text-center text-uppercase mb-4"
      style="line-height: 2px"
    >
      {{ houseAddress2 }}
    </h4>
    <p class="utility-sub-title font20">
      If it were up to us, we’d love to have you as our newest customer! We’re
      sorry that we don’t have a say in which areas are open to energy choice.
    </p>
    <p class="utility-sub-title font20">
      Check back with us in the future, we’d love to stay connected with you!
    </p>
    <p class="utility-sub-title font20">
      In the meantime, if you have a question, drop us a line and let us know
      how we can be of service.
    </p>
    <div class="col-12 text-center mb-3 mt-1">
      <button
        class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase"
        (click)="closeModal()"
      >
        Help
      </button>
    </div>
    <p class="utility-sub-title font20">
      Who do you know that would like to help make this world a better, brighter
      place while finding a deal on energy? Please let them know about us!
    </p>
    <div class="sidebar-ftr">
      <ul class="list-inline mb-3">
        <li>
          <a
            href="https://www.facebook.com/honestgorilla1/"
            class="px-0"
            target="_blank"
            ><img src="assets/images/facebook-co.svg" width="48px"
          /></a>
        </li>
        <li>
          <a
            href="https://twitter.com/honestgorilla"
            class="px-0"
            target="_blank"
            ><img src="assets/images/twitter-co.svg" width="48px"
          /></a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/honestgorilla_energy/ "
            class="px-0"
            target="_blank"
            ><img src="assets/images/instragram-co.svg" width="48px"
          /></a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
<ng-template #contact>
  <div class="modal-header py-0 px-0 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <button
        type="button"
        class="close videoclose"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeContactModal(f)"
      >
        <div class="float-right mr-2 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <h1 class="text-center conthead font-weight-bold-calibre">
      HOW CAN WE SERVE YOU
    </h1>
    <form
      name="form"
      (ngSubmit)="send($event, f, f.form.valid, 'contactModal')"
      #f="ngForm"
      novalidate
    >
      <div class="service-modal px-5">
        <div class="bdy-sec pt-0">
          <div>
            <p class="sb-ttl font-weight-normal-calibre pb-3">
              Provide your contact details, state your question, and we'll get
              back to you
            </p>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control inputshadow"
              name="fullName"
              [(ngModel)]="userObj.fullName"
              (keydown.space)="
                userObj.fullName ? null : $event.preventDefault()
              "
              #fullName="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }"
              placeholder="FULL NAME"
              required
            />
            <div
              *ngIf="f.submitted && fullName.invalid"
              class="invalid-feedback"
            >
              <div *ngIf="fullName.errors.required" class="boxcolour">
                <span
                  _ngcontent-c2=""
                  class="fa fa-exclamation-circle mr-1"
                  type="Icon"
                ></span
                >Full Name is required
              </div>
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control inputshadow"
              name="email"
              [(ngModel)]="userObj.emailId"
              (keydown.space)="userObj.emailId ? null : $event.preventDefault()"
              #email="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              required
              email
              pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
              placeholder="EMAIL ADDRESS"
            />
            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
              <div class="boxcolour" *ngIf="email.errors.required">
                <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                >Email is required
              </div>
            </div>
            <div
              [hidden]="email.valid || email.pristine || !email.errors.pattern"
              class=""
            >
              <div class="boxcolour alertMsg">
                <span class="fa fa-exclamation-circle mr-1" type="Icon"></span
                >Please enter a valid email
              </div>
            </div>
          </div>
          <div class="form-group">
            <textarea
              type="text"
              class="form-control inputshadow removeResize"
              name="contactQues"
              [(ngModel)]="userObj.contactQues"
              (keydown.space)="
                userObj.contactQues ? null : $event.preventDefault()
              "
              #contactQues="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && contactQues.invalid }"
              placeholder="WHAT'S YOUR BURNING QUESTION?"
              required
            ></textarea>
            <div
              *ngIf="f.submitted && contactQues.invalid"
              class="invalid-feedback"
            >
              <div *ngIf="contactQues.errors.required" class="boxcolour">
                <span
                  _ngcontent-c2=""
                  class="fa fa-exclamation-circle mr-1"
                  type="Icon"
                ></span
                >Please enter a value
              </div>
            </div>
          </div>
          <div class="form-group float-label-control text-center mb-1 pt-2">
            <button
              class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn"
              data-backdrop="false"
            >
              SEND
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #thank>
  <div class="modal-header pr-1 pt-1 px-0">
    <div class="col-12 text-right">
      <button
        type="button"
        class="close videoclose"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeResetModal()"
      >
        <div class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="20" />
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body pt-0">
    <div class="service-modal">
      <div class="bdy-sec">
        <div>
          <p class="sb-ttl resettxt text-center">
            Thank you! Your message has been sent. A member of our team will be
            in touch soon!
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ngx-spinner></ngx-spinner>
<ng-template #newEnergyRates>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="newEnergyProviderRates()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        THIS OFFER HAVE EXPIRED ALREADY
      </h4>
      <p class="utility-sub-title font20">
        PRICE FLASH! Due to market volatility, this price is no longer being
        offered by the energy provider you have selected. However, this update
        could possibly work in your favor!
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click the button below 👇 to see new rates.
      </p>
      <br />
      <p class="utility-sub-title font20">
        We appreciate your patience, and apologize In advance for any
        inconvenience, while we update our records. This may take a few seconds.
      </p>
      <div class="col-12 text-center">
        <button
          class="btn mr-2 ml-2 col-12 font-weight-bold-calibre contbtn text-uppercase mb-3"
          (click)="newEnergyProviderRates()"
        >
          see new rates
        </button>
      </div>
    </div>
  </div>
</ng-template>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait a few seconds while we retrieve your ESI ID
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #invalidUtility>
  <div id="invalidUtility">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="closeInvalidUtilityTemplate()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img
              src="assets/images/editchart-close.svg"
              width="17"
              style="margin-top: -10px"
            />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        Uh-oh! An Error Has Occurred
      </h4>
      <p class="utility-sub-title font20">
        It seems that you have changed your address, and in doing so, the
        product you have selected is no longer applicable.
      </p>
      <br />
      <p class="utility-sub-title font20">
        This is because the new address is located in a new utility service
        territory.
      </p>
      <br />
      <p class="utility-sub-title font20">
        Please click the button below to go back and select a new product or
        close this message and continue with your previous address.
      </p>
      <div class="col-12 text-center webview">
        <button
          id="enrollment-payment-form-submit-button"
          class="btn sectbtn my-2 text-uppercase"
          style="
            width: auto !important;
            padding-left: 25px;
            font-size: 18px !important;
            padding-right: 25px;
          "
          (click)="getRecommendationsForNewUtility()"
        >
          Go Back
        </button>
      </div>
    </div>
  </div>
</ng-template>
